import {
  Alert,
  Box,
  Button,
  IconButton,
  Link,
  Stack,
  Typography,
  alpha,
  Hidden,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
} from "@mui/material";

import SearchBar from "../components/search-bar/SearchBar";
import SvgColor from "../components/svg-color/SvgColor";
import { StyledRowSpace } from "./styles";

export const Header = ({
  goBack,
  title,
  helperText,
  leftIcon,
  onClickHelperText,
  actionButtonTitle,
  additionalButtonTitle,
  dropDownSelect,
  dropDownOptions,
  dropDownLabel,
  onClickDropDownOption,
  onClickActionButton,
  onClickAdditionalButton,
  searchBarProps,
  onClose,
  dropDownDisabled,
  titleStyle,
  onFilterClick,
  variant = "list",
  rightIcon,
  onClickRightIcon,
  tooltip,
}) => (
  <Stack sx={{ p: 2 }}>
    <StyledRowSpace>
      {leftIcon && (
        <SvgColor
          src={`/assets/icons/card/${leftIcon}.svg`}
          sx={{
            width: "25px",
            height: "25px",
            mr: 1,
            color: (theme) => theme.palette.taskboard.raisinBlack,
          }}
        />
      )}
      {goBack && (
        <IconButton
          aria-label="back"
          sx={{
            color: (theme) => theme.palette.common.black,
          }}
          onClick={goBack}
        >
          {/* <Iconify icon={'fluent:ios-arrow-24-filled'} width={20} fontWeight={900} /> */}
        </IconButton>
      )}
      {variant === "dialog" ? (
        <Typography variant="h6" sx={titleStyle}>
          {title}
        </Typography>
      ) : (
        <Hidden smDown>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Hidden>
      )}

      <Stack flexDirection="row" flex={1} justifyContent={"flex-end"}>
        {Boolean(additionalButtonTitle) && (
          <Button
            variant="outlined"
            onClick={onClickAdditionalButton}
            color="inherit"
            sx={{ mr: 2 }}
          >
            {additionalButtonTitle}
          </Button>
        )}
        {Boolean(dropDownSelect) && dropDownOptions && (
          <FormControl variant="outlined">
            <InputLabel
              sx={{
                color: (theme) => theme.palette.grey[500],

                "&.Mui-focused": {
                  color: (theme) => theme.palette.grey[500],
                },
              }}
            >
              {dropDownLabel}
            </InputLabel>

            <Select
              variant="outlined"
              value={dropDownSelect}
              label={dropDownLabel}
              disabled={dropDownDisabled}
              onChange={(event) => {
                onClickDropDownOption?.(event.target.value);
              }}
              sx={{ height: "6vh", mr: 2, fontSize: "14px", fontWeight: 700 }}
            >
              {dropDownOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {Boolean(actionButtonTitle) && (
          <Button
            variant="contained"
            onClick={onClickActionButton}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              bgcolor: "#1666EB",
            }}
          >
            {actionButtonTitle}
          </Button>
        )}
        {rightIcon && (
          <>
            <Tooltip title={tooltip}>
              <SvgColor
                src={`/assets/icons/card/${rightIcon}.svg`}
                sx={{
                  width: "25px",
                  height: "25px",
                  mr: 1,
                  mt: 0.5,
                }}
                onClick={onClickRightIcon}
              />
            </Tooltip>
          </>
        )}
      </Stack>

      {onClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          {/* <Iconify icon={'material-symbols:close'} /> */}
        </IconButton>
      )}
    </StyledRowSpace>

    {Boolean(helperText) && <Box sx={{ mt: 3 }} />}
    {Boolean(helperText) && (
      <Alert
        severity="info"
        sx={{
          bgcolor: (theme) => alpha(theme.palette.info.main, 0.16),
        }}
      >
        <Button variant="text" sx={{ padding: 0 }} onClick={onClickHelperText}>
          <Link variant="subtitle2" underline="always">
            {helperText}
          </Link>
        </Button>
      </Alert>
    )}

    {Boolean(searchBarProps) && (
      <Stack
        direction={"row"}
        alignItems="center"
        spacing={1}
        sx={{ mt: 3 }}
        justifyContent={"end"}
      >
        <Box>
          <SearchBar {...searchBarProps} fullWidth />
        </Box>
        {onFilterClick && (
          <IconButton
            aria-label="filter"
            onClick={onFilterClick}
            sx={{
              color: (theme) => theme.palette.common.black,
            }}
          >
            {/* <Iconify icon={'mdi:filter-variant'} width={24} /> */}
          </IconButton>
        )}
      </Stack>
    )}
  </Stack>
);
